import { usePickerValue as m } from "./usePickerValue.mjs";
import { usePickerViews as l } from "./usePickerViews.mjs";
import { usePickerLayoutProps as d } from "./usePickerLayoutProps.mjs";
import { buildWarning as P } from "./warning2.mjs";
const k = P(["The `renderInput` prop has been removed in version 6.0 of the Date and Time Pickers.", "You can replace it with the `textField` component slot in most cases.", "For more information, please have a look at the migration guide (https://mui.com/x/migration/migration-pickers-v5/#input-renderer-required-in-v5)."]), v = ({
  props: o,
  valueManager: s,
  valueType: n,
  wrapperVariant: i,
  inputRef: t,
  additionalViewProps: p,
  validator: u,
  autoFocusView: c
}) => {
  process.env.NODE_ENV !== "production" && o.renderInput != null && k();
  const e = m({
    props: o,
    valueManager: s,
    valueType: n,
    wrapperVariant: i,
    validator: u
  }), r = l({
    props: o,
    inputRef: t,
    additionalViewProps: p,
    autoFocusView: c,
    propsFromPickerValue: e.viewProps
  }), a = d({
    props: o,
    wrapperVariant: i,
    propsFromPickerValue: e.layoutProps,
    propsFromPickerViews: r.layoutProps
  });
  return {
    // Picker value
    open: e.open,
    actions: e.actions,
    fieldProps: e.fieldProps,
    // Picker views
    renderCurrentView: r.renderCurrentView,
    hasUIView: r.hasUIView,
    shouldRestoreFocus: r.shouldRestoreFocus,
    // Picker layout
    layoutProps: a.layoutProps
  };
};
export {
  v as usePicker
};
//# sourceMappingURL=usePicker.mjs.map
